module.exports = "<app-poi-edit-areas poi=$ctrl.poi on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-poi-edit-areas> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/areas/template.html
// module id = 429
// module chunks = 0